import Vue from 'vue'
import menuI from 'js/pages/municipality/index.js'
import {mapGetters} from 'vuex'
import template from './index.pug'
import LoginForm from './_login-form.js'

const MUNICIPALITY_RECHARGE = 'municipality-recharge'
const INFO_CARDS = 'info-cards'
const LEARN_MORE = 'learn-more'
const LOGIN = 'login'

export default Vue.extend({
  template: template(),

  components: {
    LoginForm, menuI
  },
  data() {
    return {
      showPanel: false,
      showLanguageSelector: false,
      step: LOGIN,
      openedMenu: false
    }
  },

  computed: {
    ...mapGetters(['currentUser'])
  },
  methods: {
    goToInfoCards() {
      const route = {
        name: INFO_CARDS,
        params: {country: this.country, municipality: this.loadedMunicipality}
      }
      this.$router.push(route)
    },

    moreClick() {
      this.$router.push({
        name: LEARN_MORE
      })
    },

    login() {
      this.changeStep(LOGIN)
      this.showPanel = true
    },
    changeStep(step) {
      this.step = step
    },
    closePanel() {
      this.showPanel = false
    },
    
    municipalityName() {
      if (!_.isEmpty(this.$municipality)) return undefined

      return this.$municipality.name_normalized
    },

    goToRecharge() {
      const route = {
        name: MUNICIPALITY_RECHARGE,
        params: {country: this.country, municipality: this.loadedMunicipality}
      }
      this.$router.push(route)
    }
  }
})
